<template>
  <div class="fx_home">
    <div class="home" v-if="!isMobile">
      <div class="firstSection">
        <div class="topItem">
          <div class="rightSub">
            <div class="bookLink" @click="goBook('book')"></div>
            <div class="paper-link" @click="goBook('paper')"></div>
            <div class="goVip" @click="dealgoVip"></div>
          </div>
        </div>
        <div class="bottomItem">
          <div class="leftItem">
            <div class="leftItemTitle"></div>
            <div class="leftItemDesc"></div>
            <div class="leftItemUpload">
              <div class="button-to-upload" @click="toUpload('PDFUpload')"></div>
              <div class="button-to-upload ePaper" @click="toUpload('PaperUpload')"></div>
            </div>
          </div>
          <div class="rightItem"></div>
        </div>
      </div>
      <div class="carouBooks">
        <el-carousel :interval="4000" type="card" height="27.4vw" trigger="click" arrow="always" indicator-position="none">
          <el-carousel-item v-for="(bookImg, bookIndex) in bookImgsList" :key="bookIndex">
            <div class="carouCover" @click="toGo(bookImg.link)">
              <img :src="bookImg.coverUrl" alt="" />
              <div class="carouQr">
                <vue-qr :text="bookImg.link" :size="140" :margin="2" />
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="secondSection">
        <div class="libTitle"></div>
        <el-tabs class="libWrap" v-model="activeName">
          <template v-for="(bookItem, index) in bookShelf">
            <el-tab-pane :key="index" label="" :name="bookItem.tabs">
              <iframe width="100%" height="515px" :src="bookItem.link"></iframe>
            </el-tab-pane>
          </template>
        </el-tabs>
      </div>
      <div class="lastSection">
        <div class="chosenTitle"></div>
        <div class="chosen">
          <div class="chosenItem" v-for="(caseItem, caseIndex) in caseList" :key="caseIndex" @click="toGo(caseItem.link)">
            <div class="chosenCover">
              <img :src="caseItem.coverUrl" alt="" />
              <div class="chosenQr">
                <vue-qr :text="caseItem.link" :size="70" :margin="2" />
              </div>
            </div>
            <div class="chosenLabel">
              <span>{{ caseItem.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <comFooter></comFooter>
    </div>
    <div class="mobile_home" v-else>
      <div class="mobile_center">
        <div style="height: 25px;width: 100%;"></div>
        <div class="mobile_title">
          数字报纸，富媒体电子书报刊在线发布平台
        </div>
        <div class="mobile_block">
          <div class="mobile_sbTit">
            <span class="line"></span>
            <span>特色功能</span>
            <span class="line"></span>
          </div>
          <div class="m_decItem">
            <div v-for="(item, index) in mbDescText" :key="index" class="item">
              <img :src="item.src" />
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
        <p>* 欢迎您使用电脑端上传、发布书报刊，体验更佳！</p>
        <p v-if="isLogin" class="mobile_center__quit">你好，{{ userName }} <i class="el-icon-minus"></i> <sapn @click="quit">退出</sapn></p>
        <div class="mobile_block">
          <div class="mobile_sbTit mobile_sbTit_case">
            <span class="line"></span>
            <span>精选案例</span>
            <span class="line"></span>
          </div>
          <div class="m_decItem m_decItem2">
            <div v-for="(item, index) in caseList" :key="index" class="item" @click="toGo(item.link)">
              <img :src="item.coverUrl" />
              <div class="text">{{ item.displayName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mine rightBar" v-if="isLogin" @click="goPersonalPage">我的主页</div>
      <div class="mine rightBar" v-else @click="goLogin">登录注册</div>
      <div class="cpLink about rightBar" @touchend="goAbout">关于我们</div>
      <div class="cpLink rightBar tag-read" @touchend="handleCopy" :data-clipboard-text="homeUrl">复制链接</div>
      <div class="clipboardtip" v-show="showTip">{{ clipboardtip1 }}<br />{{ clipboardtip2 }}</div>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import homeType from '@api/home'
import comFooter from '@components/commonFooter/index.vue'
import apis from '@api/login'
import { judgeIsMobile } from '@/utils'
import Clipboard from 'clipboard'
import { setEncryption } from '@/utils'
export default {
  name: 'Home',
  data() {
    return {
      bookImgsList: [
        {
          coverUrl: '//h5.founderfx.cn/TQMS/ebook/20210715/6c5b9d27ab2d406ebc216dbf226e5f6c/1.jpg?t=' + new Date().getTime(),
          link: window.location.protocol + '//www.founderfx.cn/elecPublish/content?id=1876'
        },
        {
          coverUrl: '//h5.founderfx.cn/TQMS/ebook/20210716/55894841d27b434090ee919fc2cdadef/1.jpg?t=' + new Date().getTime(),
          link: window.location.protocol + '//www.founderfx.cn/elecPublish/content?id=1881'
        },
        {
          coverUrl: '//h5.founderfx.cn/TQMS/ebook/20220106/5918c4381c3143039c12d837b13115e0/1.jpg?t=' + new Date().getTime(),
          link: window.location.protocol + '//www.founderfx.cn/elecPublish/content?id=3970'
        },
        {
          coverUrl: '//h5.founderfx.cn/TQMS/ebook/20211122/5ba2c3b2a754495ea43452781f8a30dd/1.jpg?t=' + new Date().getTime(),
          link: window.location.protocol + '//www.founderfx.cn/elecPublish/content?id=MzU3Mw%3D%3D'
        },
        {
          coverUrl: '//h5.founderfx.cn/TQMS/ebook/20211224/dff89fd709734bd39aa0624d68641b43/1.jpg?t=' + new Date().getTime(),
          link: window.location.protocol + '//www.founderfx.cn/elecPublish/content?id=3896'
        }
      ],
      mbDescText: [
        {
          src: require('@imgs/index-m-icon.png'),
          text: '一键上传创建电子书刊、数字报纸，快速生成链接、二维码'
        },
        {
          src: require('@imgs/index-m-icon2.png'),
          text: '自定义背景模板、翻书音效，微信分享标题描述'
        },
        {
          src: require('@imgs/index-m-icon3.png'),
          text: '书刊分类收纳、自定义图书排序/设置封面标签'
        },
        {
          src: require('@imgs/index-m-icon4.png'),
          text: '实时统计分析监测各项指标数据'
        }
      ],
      bookShelf: [
        {
          tabs: 'tabs1',
          label: '数字报刊',
          link: `${window.location.href}bookLibdetail?id=${setEncryption(17)}`
        },
        {
          tabs: 'tabs2',
          label: '数字期刊',
          link: `${window.location.href}bookLibdetail?id=${setEncryption(19)}`
        },
        {
          tabs: 'tabs3',
          label: '数字电子书',
          link: `${window.location.href}bookLibdetail?id=${setEncryption(20)}`
        }
      ],
      caseList: [],
      pageNo: 1,
      pageSize: 6,
      noticeDate: '(6月16日)',
      homeUrl: window.location.href,
      clipboardtip1: '您已复制本页链接，',
      clipboardtip2: '请粘贴到电脑浏览器内打开',
      showTip: false,
      timer: null,
      activeName: 'tabs1',
      loginUrl: window.PROJECT_CONFIG.BASE_URL
    }
  },
  methods: {
    toUpload(val) {
      this.$router.push({ name: 'Upload', params: { to: val } })
    },
    toGo(url) {
      const id = url.split('=')[1]
      this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'catalog')
      const encryption_id = setEncryption(id)
      let routeUrl = this.$router.resolve({
        path: '/book',
        query: { id: encryption_id }
      })
      window.open(routeUrl.href, '_blank')
    },
    init() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      homeType.homeType(params).then((res) => {
        if (res && res.data && res.status === 200) {
          this.caseList = res.data.page && res.data.page.totalCount ? res.data.page.result : []
        }
      })
    },
    dealgoVip() {
      let routeUrl = this.$router.resolve({
        path: '/openVIP'
      })
      window.open(routeUrl.href, '_blank')
    },
    goBook(param) {
      if (this.userName) {
        this.$router.push({ name: 'list', params: { to: param } })
      } else {
        this.login(true)
      }
    },
    login(isGo) {
      apis.login().then((res) => {
        if (res && res.data && res.status === 200) {
          let data = res.data
          if (data.code === 101) {
            this.$store.commit('common/UPDATE_IS_LOGIN', false)
            if (isGo) {
              window.location.href = data.data
            }
          } else if (data.data.username) {
            this.$store.commit('common/UPDATE_IS_LOGIN', true)
            localStorage.setItem('username', data.data.username)
          }
        }
      })
    },
    goAbout() {
      this.$router.push({ path: '/aboutUs' })
    },
    handleCopy() {
      // 复制粘贴板
      let clipboard = new Clipboard('.tag-read')
      clipboard.on('success', (e) => {
        this.showTip = true
        let that = this
        this.timer = setTimeout(() => {
          that.showTip = false
          clearTimeout(that.timer)
        }, 2000)
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        console.log('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    quit() {
      const url = window.location.href
      localStorage.setItem('userId', '')
      localStorage.setItem('token', '')
      // window.location.href = this.baseUrl + '/uuacLogout?_scope=1&service=' + url
      window.location.href = this.loginUrl + '/fxsso/logout?service=' + url
      localStorage.setItem('username', '')
      localStorage.setItem('isChild', '')
      this.$store.commit('manage/UPDATE_BOOKS_CURRENT_ACCOUNT', '')
    },
    goPersonalPage() {
      this.$router.push({ path: '/personal' })
    },
    goLogin() {
      window.location.href = this.loginUrl + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href)
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    },
    isLogin() {
      return this.$store.state.common.isLogin
    },
    isMobile() {
      return this.$store.state.book.isMobile
    }
  },
  created() {
    this.login(false)
    this.init()
    this.$store.commit('book/UPDATE_IS_MOBILE', judgeIsMobile())
    if (judgeIsMobile()) {
      document.body.style.minWidth = 'auto'
    }
  },
  components: {
    VueQr,
    comFooter
  }
}
</script>
<style lang="scss">
.fx_home {
  overflow: auto;
  .home {
    width: 100%;
    height: 100%;
    .firstSection {
      height: 40.4vw;
      padding: 1.7vw 13.9vw 4.9vw 15.3vw;
      position: relative;
      background: #1467ff;
      .topItem {
        .rightSub {
          display: flex;
          float: right;
          .goVip,
          .bookLink,
          .paper-link {
            cursor: pointer;
            background: no-repeat center/100%;
          }
          .goVip {
            width: 7.8vw;
            height: 1.7vw;
            background-image: url('../assets/imgs/home/openvip.png');
            margin-left: 2.3vw;
          }
          .bookLink {
            width: 5.8vw;
            height: 1.6vw;
            background-image: url('../assets/imgs/home/mybook.png');
          }
          .paper-link {
            width: 6.5vw;
            height: 1.8vw;
            background-image: url('../assets/imgs/home/myPaper.png');
            margin-left: 2.3vw;
          }
        }
        .updateFx {
          cursor: pointer;
          text-decoration: underline;
          font-size: 1vw;
          font-family: FZLTHProGlobal-Regular, FZLTHProGlobal;
          color: #ffffff;
          line-height: 1.5vw;
          display: inline-flex;
          align-items: center;
          .updateFx-logo {
            display: inline-block;
            width: 4vw;
            margin-right: 1vw;
          }
        }
      }
      .bottomItem {
        height: 29.4vw;
        margin-top: 2vw;
        display: flex;
        .leftItem {
          width: 29.3vw;
          margin-right: 5.6vw;
          .leftItemTitle,
          .leftItemDesc,
          .button-to-upload {
            background: no-repeat center/100%;
          }
          .leftItemDesc,
          .button-to-upload {
            margin-left: 0.3vw;
            margin-top: 1.7vw;
          }
          .leftItemUpload {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
          .leftItemTitle {
            height: 8.1vw;
            background-image: url('../assets/imgs/home/titleText.png');
          }
          .leftItemDesc {
            width: 28.8vw;
            height: 13.5vw;
            background-image: url('../assets/imgs/home/descGrid.png');
          }
          .button-to-upload {
            cursor: pointer;
            width: 13.9vw;
            height: 4.5vw;
            background-image: url('../assets/imgs/home/go.png');
            &.ePaper {
              background-image: url('../assets/imgs/home/goPaper.png');
            }
          }
        }
        .rightItem {
          width: 36vw;
          height: 27.3vw;
          margin-top: 2.2vw;
          background: no-repeat center/100% url('../assets/imgs/home/htmlfont.png');
        }
      }
    }
    .carouBooks {
      height: 38.1vw;
      padding: 5.1vw 20.8vw 5.6vw;
      .el-carousel__arrow {
        &:hover,
        & {
          background: transparent;
        }
        > i {
          color: #1467ff;
          font-size: 2.2vw;
          font-weight: bolder;
        }
      }
      .el-carousel__item {
        .carouCover {
          width: 19.2vw;
          height: 26vw;
          margin: 0 auto;
          padding: 0.7vw;
          box-sizing: content-box;
          > img {
            width: 100%;
            height: 100%;
            box-shadow: 0.2vw 0.2vw 0.7vw rgba(169, 169, 169, 0.5), -0.2vw -0.2vw 0.7vw rgba(169, 169, 169, 0.5);
          }
          &:hover .carouQr {
            display: flex;
          }
          .carouQr {
            display: none;
            width: 19.2vw;
            height: 26vw;
            box-sizing: content-box;
            background: rgba($color: #000000, $alpha: 0.7);
            position: absolute;
            top: 0.7vw;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .secondSection {
      width: 100%;
      background-color: #fff;
      .libTitle {
        margin: 0 auto;
        width: 66.2vw;
        height: 14.4vw;
        background: no-repeat center/100% url('../assets/imgs/home/libTitle.png');
      }
      .libWrap {
        padding: 3.3vw 0 4.3vw 0;
        text-align: center;
        width: 69.4vw;
        margin: auto;
        iframe {
          border: 2px solid #edc28c;
        }
        .el-tabs__nav-wrap::after {
          height: 0;
        }
        .el-tabs__nav {
          float: none;
          .is-active {
            border: none;
          }
          #tab-tabs1 {
            background: url('../assets/imgs/home/tabs1_1.png') no-repeat center;
            background-size: 100%;
          }
          #tab-tabs2 {
            background: url('../assets/imgs/home/tabs2_1.png') no-repeat center;
            background-size: 100%;
          }
          #tab-tabs3 {
            background: url('../assets/imgs/home/tabs3_1.png') no-repeat center;
            background-size: 100%;
          }
          #tab-tabs1.is-active {
            background: url('../assets/imgs/home/tabs1_2.png') no-repeat center;
            background-size: 100%;
          }
          #tab-tabs2.is-active {
            background: url('../assets/imgs/home/tabs2_2.png') no-repeat center;
            background-size: 100%;
          }
          #tab-tabs3.is-active {
            background: url('../assets/imgs/home/tabs3_2.png') no-repeat center;
            background-size: 100%;
          }
        }
      }
    }
    .lastSection {
      .chosenTitle {
        margin: 0 auto;
        width: 44.8vw;
        height: 14.4vw;
        background: no-repeat center/100% url('../assets/imgs/home/chosenTitle.png');
      }
      .chosen {
        height: 16.9vw;
        margin: 2.7vw auto 5.3vw;
        display: flex;
        justify-content: center;
        .chosenItem {
          width: 10.6vw;
          height: 16.9vw;
          margin-right: 1.2vw;
          cursor: pointer;
          .chosenCover {
            height: 14vw;
            background: #fff;
            position: relative;
            padding: 0.5vw 0.7vw 0.8vw;
            > img {
              width: 100%;
              height: 100%;
              box-shadow: 2px 2px 2px rgba(169, 169, 169, 0.5), -2px 0 2px rgba(169, 169, 169, 0.5);
            }
            &:hover .chosenQr {
              display: flex;
            }
            .chosenQr {
              display: none;
              width: 100%;
              height: 100%;
              background: rgba($color: #000000, $alpha: 0.7);
              position: absolute;
              left: 0;
              top: 0;
              justify-content: center;
              align-items: center;
            }
          }
          .chosenLabel {
            font-size: 1vw;
            margin: 0.1vw auto 0;
            height: 2.8vw;
            color: #000;
            text-align: center;
            width: 5.8vw;
            span {
              overflow: hidden !important;
              text-overflow: ellipsis !important;
              display: -webkit-box !important;
              -webkit-line-clamp: 2 !important;
              -webkit-box-orient: vertical !important;
              font-size: 1vw;
              font-family: FZLTHJW--GB1-0, FZLTHJW--GB1;
              line-height: 1.4vw;
            }
          }
        }
      }
    }
  }
  .mobile_home {
    position: relative;
    color: #fff;
    height: auto;
    background: #1467ff;
    .mobile_center {
      width: 72%;
      margin: 0 auto;
      .mobile_title {
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
        text-align: center;
        margin-bottom: 16px;
      }
      .mobile_sbTit {
        font-size: 16px;
        color: #f8a81b;
        display: flex;
        align-items: center;
        justify-content: space-around;
        span {
          display: inline-block;
        }
        .line {
          background: #f8a81b;
          height: 1px;
          width: 20%;
        }
      }
      .mobile_sbTit_case {
        margin-bottom: 20px;
      }
      .m_decItem {
        height: 240px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        .item {
          width: 50%;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          img {
            width: 40px;
            margin-bottom: 10px;
          }
          div {
            width: 80%;
            font-size: 12px;
          }
        }
      }
      .m_decItem2 {
        height: auto;
        padding-bottom: 10px;
        .item {
          height: 180px;
          img {
            height: 134px;
            width: auto;
          }
          div {
            height: 28px;
            text-align: center;
            overflow: hidden;
          }
        }
      }
      p {
        font-size: 12px;
        margin-bottom: 30px;
      }
      &__quit {
        text-align: center;
        .el-icon-minus {
          margin: 0 5px;
          transform: rotate(90deg);
        }
        span {
          cursor: pointer;
        }
      }
    }
    .rightBar {
      position: fixed;
      right: 0;
      font-size: 12px;
      font-weight: 500;
      width: 36px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 0 5px;
    }
    .mine {
      color: #3a3a3a;
      top: 40%;
      background: url('../assets/imgs/m_aboutUs.png') no-repeat center center;
      background-size: cover;
    }
    .cpLink {
      color: #fff;
      top: calc(40% + 170px);
      background: url('../assets/imgs/m_copyLink.png') no-repeat center center;
      background-size: cover;
    }
    .about {
      top: calc(40% + 85px);
    }
    .clipboardtip {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 53.3%;
      height: 65px;
      background: rgba(0, 0, 0, 0.85);
      border-radius: 10px;
      font-weight: 500;
      color: #ffffff;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
